export const accordionDataAyuda = [
  {
    title: '¿Cómo configuro mis dispositivos?',
    content: `<h2>TV Smart</h2>
    <p>Puedes configurar tu Tv Smart en unos pocos pasos. <br/>
    Primero, descarga la app en el Store de tu televisor.<br/>
    Una vez que lo hagas, ingresa con tu usuario y contraseña, ¡y ya estás listo para disfrutar de XDneo!</p>
    <h2>Dispositivos Android</h2>
    <p>Si tienes un Chromecast, o un Fire Stick, o un Xiaomi Mi Box o un Homatics:<br/>
    Es super fácil, en unos sencillos pasos:<br/>
    <ol>
    <li>Ingresar en el app store de tu dispositivo</li>
    <li>Bajarse la app "XDneo"</li>
    <li>Ingresa los datos de usuario y contraseña </li>
    <li>Disfruta del servicio! </li>
    <li>Si tienes dudas adicionales, escríbenos a nuestro contact center y te ayudaremos</li>
    </ol>
    
    </p>
    <h2>Dispositivos iOS</h2>
    <p>Es súper fácil:<br/>
    <ol>
      <li>Ingresar en el Apple store de tu dispositivo</li>
      <li>Bajarse la app "XDneo"</li>
      <li>Ingresa los datos de usuario y contraseña </li>
      <li>Disfruta del servicio! </li>
      <li>Si tienes dudas adicionales, escríbenos a nuestro contact center y te ayudaremos</li>
    </ol>
    `
  },
  {
    title: '¿Cómo pagar XDneo?',
    content: `<p>Aceptamos tarjetas de crédito y débito Visa y MasterCard. No te olvides de que deben estar habilitadas para transacciones por internet.</p>
    <p>Si no tienes tarjeta, no te preocupes. XDneo tiene su propia tarjeta prepago para que puedas disfrutar del servicio. Para ello ingresa aquí para ver los puntos de venta.</p>
    <p>Lamentablemente los pagos a través de prepago no están sujetos a devolución, pero como tenemos un servicio que simplemente te hipnotizará, estamos seguros que te quedarás con la experiencia XDneo para siempre.</p>`
  },
  {
    title: 'Políticas de privacidad',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Massa condimentum gravida sed ut pharetra amet vitae. Id maecenas id mattis elit velit. Quam nisi, erat velit lacus, morbi lobortis bibendum pretium nisl. At vitae eu enim quam blandit faucibus pellentesque tortor, bibendum.`
  },
  {
    title: 'Términos y condiciones del servicio',
    content: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Mollitia veniam
    reprehenderit nam assumenda voluptatem ut. Ipsum eius dicta, officiis
    quaerat iure quos dolorum accusantium ducimus in illum vero commodi
    pariatur? Impedit autem esse nostrum quasi, fugiat a aut error cumque
    quidem maiores doloremque est numquam praesentium eos voluptatem amet!
    Repudiandae, mollitia id reprehenderit a ab odit!`
  }
];